module.exports = __webpack_public_path__ + "static/media/4.970c42e1.svg";